import {
    ADD_DESTINATION,
    ADD_DESTINATION_COMPLETE,
    GET_DESTINATIONS,
    UPDATE_DESTINATION,
    DELETE_DESTINATION,
} from "../types";

const DestinationReducer = (state, action) => {
    switch (action.type) {
        case GET_DESTINATIONS:
            const destinations = action.payload;
            return {
                ...state,
                destinations: destinations,
                loading: false,
                destinationAdded: false,
            };
        case ADD_DESTINATION:
            return {
                ...state,
                destinations: [action.payload, ...state.destinations],
                loading: false,
                destinationAdded: true,
                message: "add_destination_success",
            };
        case ADD_DESTINATION_COMPLETE:
            return {
                ...state,
                destinationAdded: false,
            };
        case UPDATE_DESTINATION:
            return {
                ...state,
                destinations: state.destinations.map((d) =>
                    d.id === action.payload.id ? action.payload : d
                ),
            };
        case DELETE_DESTINATION:
            return {
                ...state,
                destinations: state.destinations.filter(
                    (d) => d.id !== action.payload
                ),
            };
        default:
            return state;
    }
};

export default DestinationReducer;
